// Types
import type {Ballot, ParentCategory, SponsorshipAd} from '../../types/ballot'
// Utils
import {addAnalytic} from '../../lib/api'
import {keenClient} from '../../utils/analytics'
// Styles
import styles from './footer-ad-contents.module.scss'

// Sample Footer ad
// {
//   "_id": "5f0759538d816d60d9edd7d7",
//   "name": "Yummy Cupcakes (50%)",
//   "advertise_name": "Yummy Cupcakes",
//   "value": "$337.50",
//   "website_link": "http://www.yummycupcakes.com/encinitas-ca/",
// // Should this be called 'horizontal_image_path'?
//   "image_path": "https://ucarecdn.com/41deb09f-ced9-4ea1-8d04-1ceef3f59d24/",
// // Should this be called 'vertical_image_path'?
//   "mobile_image_path": "https://ucarecdn.com/0698a412-09ec-40c0-a2b7-fcabec6f32ea/",
//   "updated_date_time": "2020-07-09T17:52:18.807Z"
// }

/** Runtime footer ads carry legacy API fields beyond the SponsorshipAd type */
interface FooterAdData extends SponsorshipAd {
  name?: string
  advertise_name?: string
  website_link?: string
}

interface FooterAdContentsProps {
  ballot: Ballot | null
  group: ParentCategory | null
  footerAd: FooterAdData | null
  currentWindowWidth: number
}

const FooterAdContents = ({
  ballot,
  group,
  footerAd,
  currentWindowWidth,
}: FooterAdContentsProps) => {
  const handleAdClick = (footerAd: FooterAdData) => {
    if (ballot?.new_features?.enable_best_of_internal_analytics) {
      addAnalytic({
        ballot_id: ballot?._id,
        category_id: group?._id,
        category_name: group?.parent_category_name,
        ad_clicks: {
          ad_id: footerAd._id,
          ad_name: footerAd.name,
          event_type: 'group-Ads-Click',
        },
      })
    } else {
      keenClient.recordEvent('Group-Ads-Click', {
        event_type: 'group-Ads-Click',
        ballot_id: ballot?._id,
        category_id: group?._id,
        category_name: group?.parent_category_name,
        ad_id: footerAd._id,
        groupAdName: footerAd.name,
        groupAdAdvertiserName: footerAd.advertise_name,
        websiteLink: footerAd.website_link,
        ballot: ballot,
      })
    }
  }

  return footerAd
    ? (
      <div className={styles['__container']}>
        <a
          href={footerAd.website_link}
          target='_blank'
          className={styles['footer-ad-contents']}
          rel="noreferrer"
        >
          <img
            src={currentWindowWidth >= 600 ? footerAd.image_path : footerAd.mobile_image_path}
            alt='sponsor image'
            onClick={() => handleAdClick(footerAd)}
          />
        </a>
      </div>
    )
    : null
}

export default FooterAdContents
